var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Age"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00008 13.9653C11.2946 13.9653 13.9654 11.2945 13.9654 7.99999C13.9654 4.70546 11.2946 2.03471 8.00008 2.03471C4.70554 2.03471 2.03479 4.70546 2.03479 7.99999C2.03479 11.2945 4.70554 13.9653 8.00008 13.9653Z",
    fill: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.40918 3.88384C7.40918 3.77338 7.49872 3.68384 7.60918 3.68384H8.39127C8.50173 3.68384 8.59127 3.77338 8.59127 3.88384V7.87505C8.59127 7.9465 8.62939 8.01253 8.69127 8.04826L10.9006 9.32379C10.9962 9.37902 11.029 9.50134 10.9738 9.597L10.5827 10.2743C10.5275 10.37 10.4052 10.4027 10.3095 10.3475L7.50918 8.73074C7.4473 8.69501 7.40918 8.62899 7.40918 8.55754V3.88384Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.a20738dea4b30e7536599ccb6caf74a9.svg";
export { ForwardRef as ReactComponent };